module.exports = __webpack_public_path__ + "media/images/DoorLeft-272af3b660423f06986484c2e9be6829.png";